import { render, staticRenderFns } from "./DadosGeraisOuvidoria.vue?vue&type=template&id=08a96b8a&scoped=true"
import script from "./DadosGeraisOuvidoria.vue?vue&type=script&lang=ts"
export * from "./DadosGeraisOuvidoria.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a96b8a",
  null
  
)

export default component.exports